export const handleActionPayload = (payload) => {
  return {
    payload,
  }
}

export const handleActionError = (error) => {
  return handleActionPayload({ error })
}
